import { mockNetworkDelay } from "./mockDelay";
import type { TransactionHash } from "@/types";

export interface PvEQuestData {
    title: string;
    timeRemaining: string;
    description: string;
    progress: number;
    contributedAmount: string;
    targetAmount: string;
}

export const getPvEQuest = async (): Promise<PvEQuestData> => {
    await mockNetworkDelay();

    return {
        title: "Contribute to the iUSD pool",
        timeRemaining: "2 days, 15 hours, 5 seconds",
        description: "Contribute iUSD to the pool to earn bonus bytes",
        progress: 75,
        contributedAmount: "1,500,000",
        targetAmount: "2,000,000",
    };
};

export const reallocatePoints = async (_newAddress: string): Promise<TransactionHash> => {
    await mockNetworkDelay();
    return "0x1234567890abcdef1234567890abcdef1234567890abcdef1234567890abcdef" as TransactionHash;
};
